import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ColorSketchModule } from 'ngx-color/sketch';

import { SymbologyBaseFormComponent } from '@connect-services/client/components/project-settings/symbology-edit/symbology-base-form/symbology-base-form.component';
import {
    GeometryFormGroup,
    LabelFormType,
} from '@connect-services/client/components/project-settings/symbology-edit/symbology-edit.component';
import { SymbologyLabelFormComponent } from '@connect-services/client/components/project-settings/symbology-edit/symbology-label-form/symbology-label-form.component';
import { SymbologyEditService, SymbologyStyleScope } from '@connect-services/client/services/symbology-edit.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { MapboxStyle, PermissionAliasEnum } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { FormService } from '@shared/client/services/form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ButtonComponent,
        ColorSketchModule,
        ExpansionPanelComponent,
        RessourcesModule,
        SymbologyBaseFormComponent,
        SymbologyLabelFormComponent,
    ],
    selector: 'app-symbology-geometry-form',
    styleUrls: [
        '../../symbology-edit/symbology-edit.component.scss',
        '../../edit-deposit-layer/edit-deposit-layer.component.scss',
    ],
    templateUrl: './symbology-geometry-form.component.html',
})
export class SymbologyGeometryFormComponent {
    public readonly addForm = output<void>();
    public readonly formGroup: InputSignal<FormGroup<GeometryFormGroup>> = input.required();
    public readonly geometry = input.required<MapboxStyle.TypeEnum>();
    public readonly isWide = input.required<boolean>();
    public readonly removeForm = output<void>();
    public readonly title = input.required<string>();

    protected readonly ButtonType = ButtonType;
    protected readonly formService = inject(FormService);
    protected readonly isFormVisible = computed(() => {
        switch (this.geometry()) {
            case MapboxStyle.TypeEnum.SYMBOL:
                return this.symbologyEditService.isPointFormVisible();

            case MapboxStyle.TypeEnum.LINE:
                return this.symbologyEditService.isLineFormVisible();

            case MapboxStyle.TypeEnum.FILL:
                return this.symbologyEditService.isPolygonFormVisible();
            default:
                return false;
        }
    });
    protected readonly MapboxStyle = MapboxStyle;
    protected readonly PermissionAliasEnum = PermissionAliasEnum;
    protected readonly symbologyEditService = inject(SymbologyEditService);
    protected readonly SymbologyStyleScope = SymbologyStyleScope;

    public get labelForm(): FormGroup<LabelFormType> {
        return this.formGroup().controls.label;
    }
}
